var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 488",
    width: 1500,
    height: 488,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-no-background-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #9e77ed } \n\t\t.s2 { opacity: .5;fill: #9e77ed } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("g", {
    id: "textblock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text-0",
    className: "s0",
    d: "m587.6 350.2q-24.7 0-36.7-14-12.1-14-12.1-41.5v-146.7h39v145.1q0 9.5 1.9 14.9 1.9 5.4 7.9 5.4 6.1 0 8-5.3 1.8-5.2 1.8-15v-145.1h39v146.7q0 27.5-12 41.5-12 14-36.8 14zm63.5-1.9v-170.6h40.9v21.6q2.6-10.5 8.9-17 6.3-6.5 16.8-6.5 17.3 0 25.5 10.6 8.4 10.6 8.4 30.2v131.7h-40.2v-127.5q0-5.6-2.3-9.6-2.1-3.9-6.8-3.9-6.3 0-8.3 5.7-2 5.7-2 15.3v120zm158.1 0h-41.6v-201.4h41.6zm56.9-182.1h-40.8v-28.5h40.8zm0 182.1h-40.8v-170.6h40.8zm16.1 0v-170.7h40v19.8q2.8-11 9.5-16.3 6.8-5.4 19.2-5.4 10 0 17.4 4.6 7.3 4.5 10.4 12.4 5.1-8.8 11.4-12.9 6.3-4.1 17.5-4.1 20.1 0 27.9 12.2 7.8 12.3 7.8 35.6l-0.4 124.8h-41.1v-125.5q0-16.6-8.4-16.6-5.9 0-8.4 5.7-2.6 5.8-2.6 13.7v122.7h-40.9v-125.5q0-7.2-1.5-11.7-1.5-4.4-6.4-4.4-6.3 0-8.9 6.2-2.5 6.2-2.5 14.8v120.6zm225.3 1.8q-27.3 0-39.5-13.5-12.1-13.5-12.1-43.6v-19.6h39.4v25q0 14.9 9.6 14.9 5.4 0 7.5-3.2 2.1-3.1 2.1-10.6 0-9.8-2.4-16.2-2.3-6.4-5.9-10.7-3.6-4.3-13-13.4l-17.2-17.3q-20.1-19.6-20.1-43.3 0-25.7 11.7-39.1 11.9-13.4 34.5-13.4 27.1 0 39 14.3 11.9 14.4 11.9 44.9h-40.9l-0.2-13.7q0-4-2.2-6.3-2.2-2.4-6.2-2.4-4.7 0-7 2.6-2.3 2.6-2.3 7 0 9.8 11.2 20.3l23.3 22.4q8.2 7.9 13.6 15 5.3 7.1 8.6 16.8 3.3 9.7 3.3 23 0 29.6-10.9 44.8-10.8 15.3-35.8 15.3zm96.2-1.8h-36.2v-200.3h61.2l16.8 122.1 16.8-122.1h61.6v200.3h-36.6v-144.4l-23.1 144.4h-36l-24.5-144.4zm174.1 0h-36.2v-200.3h61.2l16.8 122.2 16.8-122.2h61.7v200.3h-36.7v-144.3l-23.1 144.3h-36l-24.5-144.3z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m22.2 22.1h444.3v443.7h-444.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m44.3 0h444.3v443.7h-444.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cg-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m401.7 300.8c-15.2 15.2-35.4 23.6-56.9 23.6-21.5 0-41.6-8.4-56.9-23.6-0.5-0.5-2.5-2.5-3-3.1v15c0 5.1-4.2 9.3-9.4 9.3-5.2 0-9.4-4.2-9.4-9.3v-37.6c0-5.1 4.2-9.3 9.4-9.3h37.6c5.1 0 9.3 4.2 9.3 9.3 0 5.2-4.2 9.4-9.3 9.4h-15c0.6 0.5 2.6 2.6 3.1 3.1 11.7 11.6 27.2 18 43.6 18 16.5 0 32-6.4 43.7-18 11.6-11.7 18.1-27.1 18.1-43.6 0-16.5-6.5-32-18.1-43.6-11.7-11.6-27.2-18-43.7-18-16.4 0-31.9 6.4-43.6 18l-100.5 100.4c-15.7 15.7-36.3 23.5-56.9 23.5-20.6 0-41.3-7.8-56.9-23.5-31.4-31.3-31.4-82.3 0-113.6 31.3-31.4 82.4-31.4 113.8 0 0.3 0.3 1.8 1.8 2.2 2.2l0.9 0.8v-14.9c0-5.2 4.1-9.4 9.3-9.4 5.2 0 9.4 4.2 9.4 9.4v37.5c0 5.2-4.2 9.4-9.4 9.4h-37.5c-5.2 0-9.4-4.2-9.4-9.4 0-5.1 4.2-9.3 9.4-9.3h14.9l-0.9-0.9c-0.3-0.4-1.8-1.8-2.2-2.2-11.6-11.6-27.1-18-43.6-18-16.5 0-32 6.4-43.7 18-24 24-24 63.1 0 87.2 11.7 11.6 27.2 18 43.7 18 16.5 0 32-6.4 43.6-18l100.5-100.4c15.3-15.2 35.5-23.6 56.9-23.6 21.6 0 41.8 8.4 57 23.6 31.3 31.3 31.3 82.3-0.1 113.6z"
  }))))))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.f12b0d210276697d161be2322848f61e.svg";
export { ForwardRef as ReactComponent };